import {createSelector} from 'reselect'
import {Feature} from './constants'
import {isEnabled} from "./utils"

export const selectFeatures = (state) => state.features

export const isFeatureEnabled = (state, feature) => isEnabled(selectFeatures(state), feature)

export const isCPTBUDEnabled = createSelector(
    selectFeatures,
    (features) => isEnabled(features, Feature.CPTBUD)
)

export const isTZGEnabled = createSelector(
    selectFeatures,
    (features) => isEnabled(features, Feature.TZG)
)

export const isESTEnabled = createSelector(
    selectFeatures,
    (features) => isEnabled(features, Feature.EST)
)

export const isTSTEnabled = createSelector(
    selectFeatures,
    (features) => isEnabled(features, Feature.TST)
)

export const isUGREnabled = createSelector(
    selectFeatures,
    (features) => isEnabled(features, Feature.UGR)
)

export const isPTOEnabled = createSelector(
    selectFeatures,
    (features) => isEnabled(features, Feature.PTO)
)

export const isSDBEnabled = createSelector(
    selectFeatures,
    (features) => isEnabled(features, Feature.SDB)
)

export const isWASEnabled = createSelector(
    selectFeatures,
    (features) => isEnabled(features, Feature.WAS)
)

export const isWSDEnabled = createSelector(
    selectFeatures,
    (features) => isEnabled(features, Feature.WSD)
)


export const isTTAEnabled = createSelector(
    selectFeatures,
    (features) => isEnabled(features, Feature.TTA)
)

export const isTWSEnabled = createSelector(
    selectFeatures,
    (features) => isEnabled(features, Feature.TWS)
)

export const isBTYEnabled = createSelector(
    selectFeatures,
    (features) => isEnabled(features, Feature.BTY)
)

export const isBRAEnabled = createSelector(
    selectFeatures,
    (features) => isEnabled(features, Feature.BRA)
)

export const isURAEnabled = createSelector(
    selectFeatures,
    (features) => isEnabled(features, Feature.URA)
)

export const isOVREnabled = createSelector(
    selectFeatures,
    (features) => isEnabled(features, Feature.OVR)
)

export const isLVTEnabled = createSelector(
    selectFeatures,
    (features) => isEnabled(features, Feature.LVT)
)

export const isLTTEnabled = createSelector(
    selectFeatures,
    (features) => isEnabled(features, Feature.LTT)
)

export const isQBIEnabled = createSelector(
    selectFeatures,
    (features) => isEnabled(features, Feature.QBI)
)

export const isAnyUGREnabled = createSelector(
    selectFeatures,
    (features) => isEnabled(features, Feature.APUGR) || isEnabled(features, Feature.UGR)
)

export const isAnyTZGEnabled = createSelector(
    selectFeatures,
    (features) => isEnabled(features, Feature.APTZG) || isEnabled(features, Feature.TZG)
)



// WEBPACK FOOTER //
// ./web/js/features/selectors.js